import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgTijd = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#Tijd_svg__a)">
      <mask
        id="Tijd_svg__b"
        width={28}
        height={28}
        x={6}
        y={6}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M20 6a14 14 0 1 0 0 28 14 14 0 0 0 0-28m5.68 19.38-6.18-5.15V9h1v10.77l5.82 4.85z"
        />
      </mask>
      <g mask="url(#Tijd_svg__b)">
        <path
          fill="#F18700"
          d="M-4.52 6.04 2.55-6.21 14.8.86zM-4.52 6.04l12.25 7.07L.66 25.36zM19.98 20.18 7.73 13.11 14.8.86z"
        />
        <path
          fill="#F18700"
          d="M14.8.86 7.73 13.11-4.52 6.04z"
        />
        <path
          fill="#F7A941"
          d="m.66 25.36 7.07-12.25 12.25 7.07zM14.8.86l12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F18700"
          d="M39.3 15 27.05 7.93l7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="M34.12-4.32 27.05 7.93 14.8.86zM19.98 20.18l7.07-12.25L39.3 15z"
        />
        <path
          fill="#F18700"
          d="m25.15 39.5-12.24-7.07 7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="m.66 25.36 12.25 7.07-7.07 12.24zM5.84 44.67l7.07-12.24 12.24 7.07z"
        />
        <path
          fill="#F18700"
          d="m19.98 20.18-7.07 12.25L.66 25.36z"
        />
        <path
          fill="#F7A941"
          d="m44.47 34.32-12.24-7.07L39.3 15z"
        />
        <path
          fill="#F18700"
          d="m19.98 20.18 12.25 7.07-7.08 12.25z"
        />
        <path
          fill="#F18700"
          d="m25.15 39.5 7.08-12.25 12.24 7.07zM39.3 15l-7.07 12.25-12.25-7.07z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Tijd_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgTijd);

export default ForwardRef;
